// extracted by css-extract-rspack-plugin
export default {"Box":"layout-selector-module__Box__b6U5Hnp"};